import React, { useEffect, useState } from 'react';
import { Form, Button, Container, Row, Col, Spinner } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { adminInstance } from '../services/axiosInstance'; 

const ManageProductPage = () => {
  const { subGroupId } = useParams();

  const [groups, setGroups] = useState([]);
  const [subGroupData, setSubGroupData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Fetch group dropdown
  useEffect(() => {
    const fetchGroups = async () => {
      try {
        debugger;
        const res = await adminInstance.get(`group/get`); // Adjust endpoint if needed
        setGroups(res.data.groups || []);
      } catch (err) {
        console.error('Failed to fetch groups', err);
      }
    };

    fetchGroups();
  }, []);

  // Fetch SubGroup data if editing
  useEffect(() => {
    const fetchSubGroup = async () => {
      debugger;
      if (subGroupId) {
        try {
          const res = await adminInstance.get(`subgroup/GetSubGroupById/${subGroupId}`);
          setSubGroupData(res.data.subGroup);
        } catch (err) {
          console.error('Failed to fetch SubGroup', err);
        }
      }
      setLoading(false);
    };

    fetchSubGroup();
  }, [subGroupId]);

  const initialValues = {
    GROUP_ID: subGroupData?.GroupId || '',
    SUB_GROUP_NAME: subGroupData?.SubGroupName || '',
    SUB_GROUP_CODE: subGroupData?.SubGroupCode || '',
    DESCRIP: subGroupData?.Description || '',
    DETAIL: subGroupData?.Detail || '',
    VID1: subGroupData?.Vid1 || '',
    VID2: subGroupData?.Vid2 || '',
    VID3: subGroupData?.Vid3 || '',
    IS_ACTIVE: subGroupData?.IsActive || false
  };

  const validationSchema = Yup.object().shape({
    GROUP_ID: Yup.string().required('Group is required'),
    SUB_GROUP_NAME: Yup.string().required('Sub Group Name is required'),
    SUB_GROUP_CODE: Yup.string().required('Sub Group Code is required'),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      if (subGroupId) {
        await adminInstance.put(`subgroup/update/${subGroupId}`, values);
        alert ("Updated successfully!");
      } else {
        await adminInstance.post('subgroup/save', values);
        alert ("Saved successfully!");
      }
      //onSave?.();
    } catch (error) {
      console.error('Save failed:', error);
    } finally {
      setSubmitting(false);
    }
  };

  const handleGoBack = () => {
    navigate(-1);
  }

  if (loading) {
    return (
      <div className="text-center my-4">
        <Spinner animation="border" />
      </div>
    );
  }

  return (
    <div className="card aon-card">
        <div className="card-header aon-card-header">
            <h4>
                Manage Product
            </h4>
        </div>
        <div className="card-body aon-card-body">
          <Container>
            <h4 className="my-3">{subGroupId ? 'Edit Product' : 'Create Product'}</h4>
            <Formik initialValues={initialValues} enableReinitialize validationSchema={validationSchema} onSubmit={handleSubmit}>
              {({ handleSubmit, handleChange, handleBlur, values, touched, errors, isSubmitting }) => (
                <Form noValidate onSubmit={handleSubmit}>
                  <Row>
                    <Col md={3}>
                      <Form.Group controlId="GROUP_ID">
                        <Form.Label>Group</Form.Label>
                        <Form.Control
                          as="select"
                          name="GROUP_ID"
                          value={values.GROUP_ID}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={touched.GROUP_ID && !!errors.GROUP_ID}
                        >
                          <option value="">Select Group</option>
                          {groups && groups.map((group) => (
                            <option key={group.GroupCode} value={group.GroupCode}>
                              {group.GroupName}
                            </option>
                          ))}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">{errors.GROUP_ID}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col md={3}>
                      <Form.Group controlId="SUB_GROUP_NAME">
                        <Form.Label>Sub Group Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="SUB_GROUP_NAME"
                          value={values.SUB_GROUP_NAME}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={touched.SUB_GROUP_NAME && !!errors.SUB_GROUP_NAME}
                        />
                        <Form.Control.Feedback type="invalid">{errors.SUB_GROUP_NAME}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  
                    

                    <Col md={3}>
                      <Form.Group controlId="IS_ACTIVE" style={{margin: 20}}>
                        <Form.Check
                          type="checkbox"
                          label="Is Active?"
                          name="IS_ACTIVE"
                          checked={values.IS_ACTIVE === true || values.IS_ACTIVE === 'true'}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      </Form.Group>
                    </Col>
                    </Row>
                    <Row>
                    <Col md={3}>
                      <Form.Group controlId="SUB_GROUP_CODE">
                        <Form.Label>Sub Group Code</Form.Label>
                        <Form.Control
                          type="text"
                          name="SUB_GROUP_CODE"
                          value={values.SUB_GROUP_CODE}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={touched.SUB_GROUP_CODE && !!errors.SUB_GROUP_CODE}
                        />
                        <Form.Control.Feedback type="invalid">{errors.SUB_GROUP_CODE}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={9}>
                      <Form.Group controlId="DESCRIP">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                          type="text"
                          name="DESCRIP"
                          value={values.DESCRIP}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Form.Group controlId="DETAIL">
                    <Form.Label>Detail</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="DETAIL"
                      value={values.DETAIL}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Form.Group>

                  <Row>
                    <Col md={4}>
                      <Form.Group controlId="VID1">
                        <Form.Label>VID1</Form.Label>
                        <Form.Control
                          type="text"
                          name="VID1"
                          value={values.VID1}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      </Form.Group>
                    </Col>

                    <Col md={4}>
                      <Form.Group controlId="VID2">
                        <Form.Label>VID2</Form.Label>
                        <Form.Control
                          type="text"
                          name="VID2"
                          value={values.VID2}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      </Form.Group>
                    </Col>

                    <Col md={4}>
                      <Form.Group controlId="VID3">
                        <Form.Label>VID3</Form.Label>
                        <Form.Control
                          type="text"
                          name="VID3"
                          value={values.VID3}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <div className="mt-4 text-end">
                    <Button variant="success" type="submit" disabled={isSubmitting} style={{marginRight: 20}}>
                      {subGroupId ? 'Update' : 'Save'}
                    </Button>
                    <Button variant="primary" type="button" onClick={() => handleGoBack()}>
                      Go Back
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </Container>      
        </div>
    </div>
  );
};

export default ManageProductPage;
